// Safe browser-friendly GSAP initialization.
// Avoid ES module imports here because the theme build does not bundle modules for browser runtime.
;(function(){
	// If GSAP is loaded globally (for example via a CDN or bundled vendor file), register ScrollTrigger if present.
	var gsapObj = (typeof window !== 'undefined' && window.gsap) ? window.gsap : null;
	var ScrollTrigger = (typeof window !== 'undefined' && window.ScrollTrigger) ? window.ScrollTrigger : (gsapObj && gsapObj.ScrollTrigger ? gsapObj.ScrollTrigger : null);
	if ( gsapObj && ScrollTrigger && typeof gsapObj.registerPlugin === 'function' ) {
		gsapObj.registerPlugin( ScrollTrigger );
	}

	// Example animation (safe-guarded)
	// if ( gsapObj ) { gsapObj.to('.element', { x: 100, duration: 1 }); }
})();
